import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    card: {
        backgroundColor: theme.palette.background.dark,
    },
}));
